// extracted by mini-css-extract-plugin
module.exports = {"icon":"StreamDeletionRequestCalloutContainer-icon-2d987abcb99f9d39d1eccc771537f49f","gutter":"StreamDeletionRequestCalloutContainer-gutter-80b6769dbff027287a59cfa21609596c"};